export const RELEASE_VERSION: string = 'frontend-19.12.1';
